import React from 'react'

import { useReplies } from '../../_load/ServiceOrderLoader'

export const useNonCompliancesReplies = () => {
  const replies = useReplies()

  return React.useMemo(() => (replies || []).filter(reply => reply.isNonCompliance), [replies])
}
